export var LocalMediaStorageKeys;
(function (LocalMediaStorageKeys) {
    LocalMediaStorageKeys["HasVideo"] = "[media]hasVideo";
    LocalMediaStorageKeys["HasAudio"] = "[media]hasAudio";
})(LocalMediaStorageKeys || (LocalMediaStorageKeys = {}));
